import panelTest from './panelTest.json';
import histogram from './histogram.json';
import histogram2d from './histogram2d.json';
import pie from './pie.json';
import violin from './violin.json';
import bar from './bar.json';
import box from './box.json';

export {panelTest, histogram, histogram2d, pie, violin, bar, box};



// WEBPACK FOOTER //
// dev/percy/index.js